export default __webpack_public_path__ + "static/media/question.70bc018b.svg";